import { render, staticRenderFns } from "./ArtworkFilePreview.vue?vue&type=template&id=48266b29&"
import script from "./ArtworkFilePreview.vue?vue&type=script&lang=js&"
export * from "./ArtworkFilePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports